import { Outlet } from "react-router-dom";

const ChangePasswordLayout = () => {
  return (
    <div className="figure-wrapper gap-4 h-full">
      <img
        src={"/icons/change-password-icon.svg"}
        alt=""
        className=" mt-4 max-h-[200px]"
      ></img>

      <Outlet />
    </div>
  );
};

export default ChangePasswordLayout;
